import { CodeSection } from 'civil-status/constants/code-subject-section';
import { RiconoscimentoGenitoreItaliano } from 'civil-status/constants/id-riconoscimento-genitore-italiano';
import { TypePersistence } from 'civil-status/constants/type-section';
import { SectionVM, DatiEventoRiconoscimento, ParentVM } from 'civil-status/view-models/step-form';

export const transformerDatiEventoRiconoscimento = (
  dataSection?: SectionVM,
  dataAutorizzazioneRiconoscimento?: SectionVM,
  dataEventoRiconoscimento?: SectionVM,
  dataMatrimonioAtti?: SectionVM,
  dataAgreeSon?: SectionVM,
  subjectFiglio?: ParentVM
): DatiEventoRiconoscimento | undefined => {
  if (
    !(
      dataSection ||
      dataAutorizzazioneRiconoscimento ||
      dataEventoRiconoscimento ||
      dataMatrimonioAtti ||
      dataAgreeSon ||
      subjectFiglio
    )
  ) {
    return undefined;
  }

  return {
    key:
      dataSection?.idDatiEventoRiconoscimento ||
      dataAutorizzazioneRiconoscimento?.idDatiEventoRiconoscimento ||
      dataEventoRiconoscimento?.idDatiEventoRiconoscimento ||
      dataMatrimonioAtti?.idDatiEventoRiconoscimento ||
      dataAgreeSon?.idDatiEventoRiconoscimento ||
      subjectFiglio?.idDatiEventoRiconoscimento
        ? {
            idDatiEventoRiconoscimento:
              dataSection?.idDatiEventoRiconoscimento ||
              dataAutorizzazioneRiconoscimento?.idDatiEventoRiconoscimento ||
              dataEventoRiconoscimento?.idDatiEventoRiconoscimento ||
              dataMatrimonioAtti?.idDatiEventoRiconoscimento ||
              dataAgreeSon?.idDatiEventoRiconoscimento ||
              subjectFiglio?.idDatiEventoRiconoscimento,
          }
        : undefined,
    mesiDalConcepimento: dataSection?.conceivedMonth
      ? Number.parseInt(dataSection?.conceivedMonth, 10)
      : undefined,
    datiProdotti:
      dataEventoRiconoscimento?.codeSection === CodeSection.DATI_GENERALI_RICO_GEN
        ? undefined
        : dataAutorizzazioneRiconoscimento?.presentationDocument ||
          dataEventoRiconoscimento?.presentationDocument ||
          dataMatrimonioAtti?.presentationDocumentRecognition ||
          undefined,
    assenzaFiglio:
      dataEventoRiconoscimento?.typeDeclaration || dataAgreeSon?.typeDeclaration || undefined,
    descrizioneAssensoReso:
      dataAgreeSon?.consentReturnedBefore ||
      dataEventoRiconoscimento?.consentReturnedBefore ||
      undefined,
    flagRiconosciutoDalPadre: subjectFiglio
      ? subjectFiglio.generality?.isRecognizedGroom
        ? '1'
        : '0'
      : dataEventoRiconoscimento
      ? dataEventoRiconoscimento?.typeSection === TypePersistence.DATI_EVENTO_RICONOSCIMENTO_P ||
        dataEventoRiconoscimento.parentRecognition === RiconoscimentoGenitoreItaliano.Padre ||
        dataEventoRiconoscimento.parentRecognition === RiconoscimentoGenitoreItaliano.Entrambi
        ? '1'
        : '0'
      : undefined,
    flagRiconosciutoDallaMadre: subjectFiglio
      ? subjectFiglio.generality?.isRecognizedWife
        ? '1'
        : '0'
      : dataEventoRiconoscimento
      ? dataEventoRiconoscimento?.typeSection === TypePersistence.DATI_EVENTO_RICONOSCIMENTO_M ||
        dataEventoRiconoscimento.parentRecognition === RiconoscimentoGenitoreItaliano.Madre ||
        dataEventoRiconoscimento.parentRecognition === RiconoscimentoGenitoreItaliano.Entrambi
        ? '1'
        : '0'
      : undefined,
    flagInfraQuattordicenne: dataEventoRiconoscimento
      ? '0'
      : dataMatrimonioAtti
      ? dataMatrimonioAtti.isSonUnderFourteen
        ? '1'
        : '0'
      : undefined,
    flagPreMorto: dataEventoRiconoscimento ? '0' : undefined,
    flagPresenzaDiscendenti: dataEventoRiconoscimento ? '0' : undefined,
    sceltaCognome: dataEventoRiconoscimento?.changeSurname || undefined,
    dataComunicazione: dataEventoRiconoscimento?.dateCommunication
      ? dataEventoRiconoscimento?.dateCommunication?.toFormat('yyyy-MM-dd')
      : undefined,
    tipoSezione:
      dataSection?.typePersistence ||
      dataEventoRiconoscimento?.typePersistence ||
      dataAgreeSon?.typePersistence ||
      undefined,
    codiceSezione:
      dataSection?.codeSection ||
      dataEventoRiconoscimento?.codeSection ||
      dataAgreeSon?.codeSection ||
      undefined,
  };
};
